import React, { forwardRef } from 'react'
import { Scrollbars } from 'react-custom-scrollbars-2'

const ScrollBar = forwardRef((props, ref) => {
  const { direction = 'ltr', customPaddingTop, ...rest } = props

  return (
    <Scrollbars
      ref={ref}
      renderView={(props) => (
        <div
          {...props}
          style={{
            ...props.style,
            paddingTop: customPaddingTop,
            marginRight:'-8px',
            ...(direction === 'rtl' && {
              marginLeft: props.style.marginRight,
              marginRight: 0,
            }),
          }}
        />
      )}
      {...rest}
    />
  )
})

export default ScrollBar
